import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-simple-switch',
	templateUrl: './simple-switch.component.html',
	styleUrls: ['./simple-switch.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SimpleSwitchComponent {
	@Input() id: string;

	@Input() checked: boolean;

	@Input() form: UntypedFormGroup;

	@Input() label: string;
}
